import type { InstrumentTaxonomyClassDto, UntrackedAssetCatalogDto } from '@peritasai/types';
import { UntrackedAssetType } from '@peritasai/types';

export class UntrackedAssetCatalogEntity {
  public readonly id: string;
  public readonly type: UntrackedAssetType;
  public readonly name: string;
  public readonly productNumber: string | null;
  public readonly manufacturer: string | null;
  public readonly description: string | null;
  public readonly cost: number | null;
  public readonly isActive: boolean;
  public readonly metadata: Record<string, unknown> | null;
  public readonly createdAt: string | null;
  public readonly updatedAt: string | null;
  public readonly instrumentTaxonomyClassId: number | null;
  public readonly instrumentTaxonomyClassName: string | null;
  public readonly instrumentTaxonomyCategoryName: string | null;

  constructor(dto: UntrackedAssetCatalogDto) {
    this.id = dto.id;
    this.type = dto.type;
    this.name = dto.name;
    this.productNumber = dto.productNumber ?? null;
    this.manufacturer = dto.manufacturer ?? null;
    this.description = dto.description ?? null;
    this.cost = dto.cost ?? null;
    this.isActive = dto.isActive;
    this.metadata = dto.metadata ?? null;
    this.createdAt = dto.createdAt ?? null;
    this.updatedAt = dto.updatedAt ?? null;
    this.instrumentTaxonomyClassId = dto.instrumentTaxonomyClassId ?? null;
    this.instrumentTaxonomyClassName = dto.instrumentTaxonomyClassName ?? null;
    this.instrumentTaxonomyCategoryName = dto.instrumentTaxonomyCategoryName ?? null;
  }

  get taxonomyClass(): InstrumentTaxonomyClassDto | null {
    if (this.instrumentTaxonomyClassId == null || this.instrumentTaxonomyClassName == null) {
      return null;
    }
    return { id: this.instrumentTaxonomyClassId, name: this.instrumentTaxonomyClassName, images: [] };
  }

  get isInstrument(): boolean {
    return this.type === UntrackedAssetType.INSTRUMENT;
  }
}
